import { GetterTree } from 'vuex'
import CookiesState from '../types/CookiesState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<CookiesState, RootState> = {
  getCookieConsent: state => state.cookieConsent
}

export default getters
